import React from "react";
import "./Header.css";
import { useAccount, useNetwork, useSwitchNetwork } from "wagmi";
import { useWeb3Modal } from "@web3modal/react";

const Header = () => {
  const { chain } = useNetwork();
  const { chains, switchNetwork } = useSwitchNetwork();
  const { address } = useAccount();
  const { open } = useWeb3Modal();
  return (
    <div>
      <nav className="py-2 custom_navbar navbar navbar-expand navbar-light">
        <div className="container">
          <a href="/" className="navbar-brand">
            <div className="logo-wrap">
              <div className="lg-lft">
                <img
                  className="img-fluid"
                  src="https://shibarium.shib.io/assets/images/Shibarium%20white@2x.png"
                  alt="site-logo"
                  width={220}
                />
              </div>
              <div className="lg-rt">
                <img
                  className="img-fluid"
                  src="https://shibarium.shib.io/assets/images/Shibarium%20Pictogram@2x.png"
                  alt="site-logo"
                  width={150}
                />
              </div>
            </div>
          </a>
          <div className="navbar-collapse collapse" id="basic-navbar-nav">
            <div className="ms-auto align-items-center navbar-nav">
              <div className="button-wrap cus_dropdown nav-item"
               onClick={() =>
                address
                  ? chain?.id == chains[0]?.id
                    ? open()
                    : switchNetwork?.(chains[0]?.id)
                  : open()
              }
              >
                <a className="d-none launch-btn" >
                  <img
                    className="img-fluid"
                    src="../../assets/images/launch-app.png"
                    alt=""
                    width={30}
                  />
                </a>
                <a className="btn primary-btn ff-mos" >
                {address ? (
                    chain?.id == chains[0]?.id || chain?.id == chains[1]?.id ? (
                      address ? (
                        <>
                          {`${address.substring(0, 6)}...${address.substring(
                            address.length - 4
                          )}`}
                        </>
                      ) : (
                        "connect wallet"
                      )
                    ) : (
                      "Switch NewWork"
                    )
                  ) : (
                    "Connect Wallet"
                  )}
                </a>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Header;
